import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=10c97fbe"
import script from "./Statement.vue?vue&type=script&lang=js"
export * from "./Statement.vue?vue&type=script&lang=js"
import style0 from "./Statement.vue?vue&type=style&index=0&id=10c97fbe&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c97fbe')) {
      api.createRecord('10c97fbe', component.options)
    } else {
      api.reload('10c97fbe', component.options)
    }
    module.hot.accept("./Statement.vue?vue&type=template&id=10c97fbe", function () {
      api.rerender('10c97fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/Statement.vue"
export default component.exports